import React, { useEffect, useState } from "react";
import { Button, Form, Input, Select, message, Table, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import back_img from "../../../assests/images/rightVector.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { checkSpace, checkSpecialCharacter, getUserAndPremiseId } from "../../../utils";
import { postMarkReturnRevoke, postMarkReturnRevokeClear } from "../../../actionsMethods/manifestMethods";

const returnRevokeOptions = [
  { label: "RETURN_REVOKE", value: "RETURN_REVOKE" },
];

function MarkReturnRevoke() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]);
  const [currentSubmission, setCurrentSubmission] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const markReturnRevokeResult = useSelector(
    (state) => state?.manifestReducer?.postMarkReturnRevokeReducer,
    shallowEqual
  );

  useEffect(() => {
    if (markReturnRevokeResult?.result) {
      setIsSubmitting(false);
      if (markReturnRevokeResult.result.status !== false) {
        message.success(markReturnRevokeResult.result.message || "Submitted successfully");
        if (currentSubmission) {
          setTableData((prev) => [
            {
              key: `${currentSubmission.awbNumber}-${Date.now()}`,
              awbNumber: currentSubmission.awbNumber,
              status: "Return revoked processed successfully",
            },
            ...prev,
          ]);
        }
        form.resetFields();
        form.setFieldsValue({ status: "RETURN REVOKE" });
      } else {
        message.error(markReturnRevokeResult.result.message || "Failed to mark return revoke");
      }
      dispatch(postMarkReturnRevokeClear());
      setCurrentSubmission(null);
    }

    if (markReturnRevokeResult?.error) {
      setIsSubmitting(false);
      message.error(markReturnRevokeResult.error?.message || "Something went wrong");
      dispatch(postMarkReturnRevokeClear());
      setCurrentSubmission(null);
    }
  }, [markReturnRevokeResult, dispatch, form, currentSubmission]);

  const columns = [
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
      width: 220,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 180,
      render: (text) => (
        <span style={{ color: "#52c41a", fontWeight: "600" }}>
          {text}
        </span>
      ),
    },
  ];

  const onFinish = (values) => {
    const userInfo = getUserAndPremiseId();
    const payload = {
      barcode: values.awbNumber,
      userId: userInfo?.userId,
    };
    setIsSubmitting(true);
    setCurrentSubmission(values);
    dispatch(postMarkReturnRevoke(payload));
  };

  return (
    <Spin
      spinning={isSubmitting}
      indicator={<img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} alt="loader" />}
    >
      <div style={{ padding: "20px", background: "#F8FAFC", minHeight: "100vh" }}>
        <div
          style={{
            background: "#fff",
            padding: "16px 24px",
            borderRadius: "8px",
            boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
          }}
        >
          <div style={{ marginBottom: "24px", display: "flex", alignItems: "center" }}>
            <img
              src={back_img}
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer", marginRight: "8px" }}
              alt="back"
            />
            <h1 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: "#101828" }}>
              Mark Return Revoke
            </h1>
          </div>

          <Form form={form} layout="vertical" onFinish={onFinish} className="global-form">
            <div style={{ display: "flex", gap: "12px", alignItems: "flex-start", flexWrap: "wrap" }}>
              <div style={{ width: 260, minHeight: 86 }}>
                <Form.Item
                  label="AWB Number"
                  name="awbNumber"
                  rules={[{ required: true, message: "Please enter the AWB number" }]}
                  style={{ marginBottom: 0 }}
                >
                  <Input
                    size="large"
                    placeholder="Enter AWB number"
                    style={{ borderRadius: "8px" }}
                    onKeyPress={(e) => {
                      if (checkSpecialCharacter(e) || checkSpace(e)) e.preventDefault();
                    }}
                  />
                </Form.Item>
              </div>

              <div style={{ width: 220, minHeight: 86 }}>
                <Form.Item
                  label={<span className="mark-undelivered-field-title">Status</span>}
                  name="status"
                  initialValue="RETURN REVOKE"
                  rules={[{ message: "Please select status" }]}
                  style={{ marginBottom: 0 }}
                >
                  <Select
                    size="large"
                    options={returnRevokeOptions}
                    disabled
                    style={{
                      borderRadius: "5px",
                    }}
                  />
                </Form.Item>
              </div>

            </div>
            <div style={{ marginTop: "12px" }}>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  disabled={isSubmitting}
                  className="save-btn mark-undelivered-submit-btn"
                  style={{ borderRadius: "5px" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </div>
          </Form>

          <div style={{ marginTop: "22px" }}>
            <Table
              columns={columns}
              dataSource={tableData}
              pagination={{ pageSize: 10 }}
              locale={{ emptyText: "No return revoke marked yet" }}
              scroll={{ x: 700 }}
            />
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default MarkReturnRevoke;
